import React from "react";

const TermsConditions = () => {
  const contactEmail = "support@numbers.ag";

  return (
    <div
      style={{
        lineHeight: "1.4",
        fontSize: "18px",
        maxWidth: "1400px",
        margin: "0 auto",
        padding: "20px",
      }}
    >
      <h1
        style={{
          textAlign: "center",
          marginBottom: "30px",
        }}
        className="title-cool"
      >
        Terms &amp; Conditions
      </h1>

      <p style={{ marginBottom: "15px" }}>
        Welcome to Numbers.AG ("we," "our," or "us"). These Terms and Conditions
        ("Terms") govern your access to and use of our website, AI-based tools,
        services, content, and data, including any subscription features
        (collectively, the "Service"). By accessing or using our Service, you
        agree to be bound by these Terms. If you do not agree, do not use the
        Service.
      </p>

      <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>
        1. Use of the Service
      </h2>
      <ul style={{ margin: "10px 0", paddingLeft: "20px" }}>
        <li style={{ marginBottom: "5px" }}>
          You must be at least 18 years old to use the Service.
        </li>
        <li style={{ marginBottom: "5px" }}>
          You agree to use the Service only for lawful purposes and in
          compliance with all applicable laws and regulations.
        </li>
        <li style={{ marginBottom: "5px" }}>
          You agree not to misuse, resell, or repurpose our data, AI models, or
          content for unauthorized commercial purposes.
        </li>
      </ul>

      <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>
        2. Subscription and Access
      </h2>
      <ul style={{ margin: "10px 0", paddingLeft: "20px" }}>
        <li style={{ marginBottom: "5px" }}>
          Access to certain features may require a paid subscription. You agree
          to provide accurate and complete billing information.
        </li>
        <li style={{ marginBottom: "5px" }}>
          Subscriptions renew automatically unless canceled before the renewal
          date.
        </li>
        <li style={{ marginBottom: "5px" }}>
          We reserve the right to modify or discontinue the Service (or any part
          of it) at any time, with or without notice.
        </li>
      </ul>

      <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>
        3. No Financial Advice
      </h2>
      <ul style={{ margin: "10px 0", paddingLeft: "20px" }}>
        <li style={{ marginBottom: "5px" }}>
          The Service is provided for informational and educational purposes
          only.
        </li>
        <li style={{ marginBottom: "5px" }}>
          The AI-generated content, market interpretations, and data
          visualizations are not intended as investment advice or
          recommendations.
        </li>
        <li style={{ marginBottom: "5px" }}>
          You are solely responsible for your trading decisions and any
          financial losses incurred.
        </li>
      </ul>

      <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>
        4. AI Interactions and Data Input
      </h2>
      <ul style={{ margin: "10px 0", paddingLeft: "20px" }}>
        <li style={{ marginBottom: "5px" }}>
          Users may input data or ask questions of the AI system. The outputs
          generated are based on patterns and historical analysis but do not
          guarantee accuracy or future outcomes.
        </li>
        <li style={{ marginBottom: "5px" }}>
          We disclaim any liability for actions taken based on AI responses or
          data interpretations.
        </li>
        <li style={{ marginBottom: "5px" }}>
          The AI does not understand context as a human would and may return
          outdated or imprecise information.
        </li>
      </ul>

      <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>
        5. Limitation of Liability
      </h2>
      <p style={{ marginBottom: "15px" }}>
        To the maximum extent permitted by law, we disclaim any and all
        liability for any loss or damage arising from:
      </p>
      <ul style={{ margin: "10px 0", paddingLeft: "40px" }}>
        <li style={{ marginBottom: "5px" }}>
          reliance on data or AI-generated content;
        </li>
        <li style={{ marginBottom: "5px" }}>
          delays or interruptions in the Service;
        </li>
        <li style={{ marginBottom: "5px" }}>
          errors, inaccuracies, or omissions;
        </li>
        <li style={{ marginBottom: "5px" }}>
          third-party data feeds or tools integrated with our platform.
        </li>
      </ul>

      <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>
        6. Intellectual Property
      </h2>
      <ul style={{ margin: "10px 0", paddingLeft: "20px" }}>
        <li style={{ marginBottom: "5px" }}>
          All content, tools, AI models, and graphics on the site are the
          property of Numbers.AG or its licensors.
        </li>
        <li style={{ marginBottom: "5px" }}>
          You may not reproduce, modify, or distribute any part of the Service
          without prior written permission.
        </li>
      </ul>

      <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>
        7. Termination
      </h2>
      <p style={{ marginBottom: "15px" }}>
        We reserve the right to suspend or terminate your access to the Service
        at any time for violations of these Terms or misuse of the platform.
      </p>

      <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>
        8. Modifications
      </h2>
      <p style={{ marginBottom: "15px" }}>
        We may update these Terms from time to time. We will post the revised
        Terms on this page and update the "Last Updated" date. Continued use of
        the Service after changes constitutes your acceptance.
      </p>

      <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>
        9. Governing Law
      </h2>
      <p style={{ marginBottom: "15px" }}>
        These Terms are governed by and construed in accordance with the laws of
        State of Florida, US without regard to its conflict of law principles.
      </p>

      <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>
        10. Regulatory Compliance and Data Retention Acknowledgement
      </h2>

      <p style={{ marginBottom: "15px" }}>
        <strong>10.1 U.S. Regulatory Status.</strong> By using Numbers.ag as a
        free or subscription-based Service, you acknowledge that Numbers.AG is a
        United States–based Commodity Trading Advisor ("CTA") registered with
        the Commodity Futures Trading Commission ("CFTC") and a member of the
        National Futures Association ("NFA"). As such, Numbers.AG is strictly
        required by U.S. federal law (including, but not limited to, CFTC
        Regulation 1.31) to maintain comprehensive books and records of all
        business activities.
      </p>

      <p style={{ marginBottom: "15px" }}>
        <strong>10.2 Mandatory Retention Period.</strong> By using the Service,
        you also acknowledge and agree that Numbers.AG is legally mandated to
        retain account data, transaction records, and communications for a
        minimum period of five (5) years. This retention period applies
        regardless of account closure, service termination, or requests for data
        deletion.
      </p>

      <p style={{ marginBottom: "15px" }}>
        <strong>10.3 Limitation of Data Subject Rights.</strong> If you are
        located in the European Economic Area (EEA), United Kingdom, or other
        jurisdictions with data protection laws:
      </p>
      <ul style={{ margin: "10px 0", paddingLeft: "20px" }}>
        <li style={{ marginBottom: "5px" }}>
          <strong>Qualification of Rights:</strong> You acknowledge that rights
          such as the "Right to Erasure" (GDPR Art. 17) and the "Right to
          Restrict Processing" (GDPR Art. 18) are not absolute and are limited
          where processing is necessary for compliance with a legal obligation
          or the establishment, exercise, or defense of legal claims.
        </li>
        <li style={{ marginBottom: "5px" }}>
          <strong>Regulatory Priority:</strong> You agree that Numbers.AG's
          obligation to comply with U.S. commodities laws constitutes a
          legitimate and overriding basis for the retention of your data.
        </li>
        <li style={{ marginBottom: "5px" }}>
          <strong>Denial of Deletion:</strong> Requests to delete or "forget"
          data that falls under the scope of mandatory U.S. regulatory
          recordkeeping will be denied or limited to the extent necessary to
          maintain compliance with the CFTC and NFA.
        </li>
      </ul>

      <p style={{ marginBottom: "15px" }}>
        <strong>10.4 Condition of Service.</strong> The processing and retention
        of data as described in this section is a core condition of Numbers.AG's
        ability to provide you with the Service. If you do not agree to these
        retention requirements, you should not use the Service.
      </p>

      <p style={{ marginBottom: "15px" }}>
        <strong>10.5 GLBA Privacy Notice and Opt-Out Rights.</strong>
      </p>
      <ul style={{ margin: "10px 0", paddingLeft: "20px" }}>
        <li style={{ marginBottom: "5px" }}>
          <strong>Notice Receipt:</strong> You acknowledge that you have been
          provided with an Initial Privacy Notice located at{" "}
          <a href="/privacy-policy">https://numbers.ag/privacy-policy</a>) as
          required by the Gramm-Leach-Bliley Act (GLBA) and CFTC Regulation
          160.4.
        </li>
        <li style={{ marginBottom: "5px" }}>
          <strong>Information Sharing:</strong> You acknowledge that Numbers.AG
          does not share Nonpublic Personal Information (NPI) with nonaffiliated
          third parties except as permitted by law for everyday business
          purposes (e.g., processing transactions, maintaining your account, or
          responding to legal requirements).
        </li>
        <li style={{ marginBottom: "5px" }}>
          <strong>Opt-Out:</strong> Because Numbers.AG does not share your NPI
          for purposes that trigger an opt-out right under the GLBA (such as
          marketing to nonaffiliated third parties), no opt-out is currently
          required. If our sharing practices change, we will provide you with a
          revised notice and an opportunity to opt out before such sharing
          occurs.
        </li>
      </ul>

      <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>10. Contact</h2>
      <p style={{ marginBottom: "15px" }}>
        If you have any questions about these Terms, please contact us at:{" "}
        <a
          href={`mailto:${contactEmail}`}
          style={{ fontWeight: "bold", fontSize: "16px" }}
        >
          {contactEmail}
        </a>
      </p>
    </div>
  );
};

export default TermsConditions;
